export const BuildInfo = {timestamp:1783707436000}
